export default __webpack_public_path__ + "static/1-ccfbc19b50f28c6b25949959d86f5466.png";